
// import './IComponents.css';
import Logo from '../Icons/NavLogo.svg';
import { useState, useRef, useEffect, useContext } from 'react';
import {ScreenBusyContext} from "../../App";

export default function Navbar(){

    // Navbar Context

    const screenBusyContext = useContext(ScreenBusyContext);  
 
    const { screenBusy, setScreenBusy } = screenBusyContext!;

    // Used when user scrolls down
    const [isActive, setActive] = useState(false);

    // Ref for navigation bar
    const navRef = useRef<HTMLElement>(null);

    // Ref for navigation hover box
    const navHoverRef = useRef<HTMLDivElement>(null);

    // Assign event listeners
    useEffect(() => {

        // retrieve navbar hover area (orange part)
        const navHoverArea = navRef.current!;

        const MouseOver = (e : Event) =>{
            setActive(false);
        }
        const MouseLeave = (e : Event) => {
            setActive(true);
        }
        if (screenBusy){

          
            setActive(true);

            return () => {
                navHoverArea.removeEventListener('mouseover', MouseOver);
                navHoverArea.removeEventListener('mouseleave', MouseLeave);
            }
        } else {
            if(isActive){
                navHoverArea.addEventListener('mouseover', MouseOver);
                navHoverArea.addEventListener('mouseleave', MouseLeave);
            } else {
    
                return () => {
                    navHoverArea.removeEventListener('mouseover', MouseOver);
                    navHoverArea.removeEventListener('mouseleave', MouseLeave);
                }
            }

        }




    },[isActive])

    useEffect(() => {
        console.log(`READING FROM NAVBAR COMPONENT ${screenBusy}`);
    },[screenBusy])

    useEffect(()=> {

        const navEl = navRef.current;
        
        console.log(navEl);
        if (!navEl) return; 



        const onScroll = (e : Event) => {
            // get positional values of navbar
            const navBarPos = navEl.getBoundingClientRect();
            
            // get the y position of the navbar
            const yPos : number = navBarPos.y

            if (window.scrollY > 0 || screenBusy ){
                setActive(true);
            }else{
                setActive(false);
            }
        }

        window.addEventListener('scroll', onScroll);

    }, [])

    
    return(
        <>
            <nav ref={navRef} className={isActive ?  "navbar active" : "navbar"} id={"nav"}>

                
                <div className={ isActive ? "nav-underhead active" : "nav-underhead"} >
                    <div className={isActive ? "nav-content active" : "nav-content"}> 
                        <a className={"logo-link"} href={'/'}>
                            <img className={"nav-logo"} src={Logo} />
                        </a>
                        <ul className={"nav-links"}>
                            <li className={"nav-link"}>
                                <a href="/">Home</a>
                            </li>
                            <li className={"nav-link"}>
                                <a href="/Portfolio">Portfolio</a>
                            </li>
                            <li className={"nav-link"}>
                                <a href="/Contact">Contact</a>
                            </li>
                        </ul>
                    </div>
                </div>
                {/* <div ref={navHoverRef} className={isActive ? "nav-hover-box active" : "nav-hover-box"}></div> */}
            </nav>
            
        </>

    );



}